import { render, staticRenderFns } from "./InterDomainMetrics.vue?vue&type=template&id=1d58b144&"
import script from "./InterDomainMetrics.vue?vue&type=script&lang=js&"
export * from "./InterDomainMetrics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports